import './index.scss';
import React from 'react';
import { X } from 'react-feather';
import '@styles/react/libs/flatpickr/flatpickr.scss';
import { Hebrew as Hebrew } from 'flatpickr/dist/l10n/he.js';
import Flatpickr, { DateTimePickerProps } from 'react-flatpickr';
import { default as English } from 'flatpickr/dist/l10n/default.js';

interface DatePickerProps extends DateTimePickerProps {
  value?: Date[];
  onChange: (date: Date[]) => void;
  placeholder?: string;
  allowedDays?: number[];
  minDate?: any;
  maxDate?: any;
  id: string;
  no_clear?: boolean;
}

const DatePicker = React.forwardRef((props: DatePickerProps, ref) => {
  const shouldDisableDay = (date: Date) => {
    const { allowedDays } = props;

    if (!allowedDays) {
      return false;
    }

    if (allowedDays.length === 0) {
      return false;
    }

    return !allowedDays.includes(date.getDay() + 1);
  };

  const onClickClearDate = () => {
    props.onChange(undefined!);
  };

  const hebrewMode = localStorage.getItem('i18nextLng') === 'he';
  const rtlLanguage = hebrewMode ? Hebrew : English;

  return (
    <div className="date-picker-container">
      <Flatpickr
        className="form-control"
        value={props.value}
        onChange={props.onChange as any}
        placeholder={props.placeholder}
        id={props.id}
        options={{
          minDate: props.minDate,
          maxDate: props.maxDate,
          disable: [
            function (date) {
              // return true to disable
              return shouldDisableDay(date);
            },
          ],
          locale: rtlLanguage,
        }}
      />
      {props.value && !props.no_clear && Boolean(props.value.length) && (
        <div className="date-picker-clear-button" onClick={onClickClearDate}>
          <X />
        </div>
      )}
    </div>
  );
});

export default DatePicker;
